module.exports = __webpack_public_path__ + "img/4c584f55-e35b-4020-abd2-6df87d6137dc.webp.d436a2b6.jpg";